import { fromJS } from 'immutable';
import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  UPLOAD_PERCENTAGE,
  UPLOAD_PROGRESS_VISIBILITY,
  UPLOAD_FILE_SUCCESS,
  REMOVE_FILE_SUCCESS,
  LOAD_CLAIM_ATTACHMENTS_SUCCESS,
  RESET,
  VALIDATE_FILE,
  RUN_REQUIRED_DOC_VALIDATION,
  RUN_REQUIRED_DOC_VALIDATION_SUCCESS,
  LOAD_VALIDATION_MESSAGES,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    attachDocuments: [],
    uploadPercentage: 0,
    progressBarVisibility: false,
    showWarningMissingRequiredDocument: false,
    showWarningInvalidRequiredDocument: false,
    warningMissingRequiredDocument: null,
    validationMessages: [],
  },
  errors: [],
});

function stepSupportingDocumentsReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  const attachDocumentList = state.getIn(['form', 'attachDocuments']);
  const updatedAttachments = attachDocumentList.toJS();
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload ? fromJS({ form: action.payload }) : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case UPLOAD_PERCENTAGE:
      return state.setIn(['form', 'uploadPercentage'], action.percent);
    case UPLOAD_PROGRESS_VISIBILITY:
      return state.setIn(['form', 'progressBarVisibility'], action.visible);
    case VALIDATE_FILE:
      const attachDocuments = state.getIn(['form', 'attachDocuments']);

      const updatedFiles = attachDocuments.map(file => {
        if (file.id === action.file.id) {
          file.success = action.file.success;
          file.message = action.file.message;
        }
        return file;
      });

      return state.setIn(['form', 'attachDocuments'], fromJS(updatedFiles));
    case RUN_REQUIRED_DOC_VALIDATION:
      action.attachmentIds.forEach(id => {
          const file = updatedAttachments.find(f => f.id === id);
          if (file) {
            file.message = "Pending";
          }
        });

      return state.setIn(['form', 'attachDocuments'], fromJS(updatedAttachments));
    case RUN_REQUIRED_DOC_VALIDATION_SUCCESS:
      if (!action.data || !Array.isArray(action.data)) {
        return state;
      }

      action.data.forEach(item => {
        const file = updatedAttachments.find(f => f.id === item.AttachmentId);
        if (file) {
          file.success = item.Success;
          file.message = item.Message;
        }
      });

      return state.setIn(['form', 'attachDocuments'], fromJS(updatedAttachments));
    case UPLOAD_FILE_SUCCESS:
      return state.setIn(
        ['form', 'attachDocuments'],
        state.getIn(['form', 'attachDocuments']).push(action.file)
      );
    case LOAD_VALIDATION_MESSAGES: {
      const messages = state.getIn(['form', 'validationMessages']);
      const idx = messages.findIndex(
        msg =>
          (msg.get('RequiredDocumentId') || msg.get('requiredDocumentId')) ===
          (action.message.RequiredDocumentId || action.message.requiredDocumentId)
      );
      if (idx !== -1) {
        // Update existing message
        return state.setIn(
          ['form', 'validationMessages', idx],
          fromJS(action.message)
        );
      }
      // Add new message
      return state.setIn(
        ['form', 'validationMessages'],
        messages.push(fromJS(action.message))
      );
    }
    case REMOVE_FILE_SUCCESS:
      const newState = state.setIn(
        ['form', 'attachDocuments'],
        fromJS(
          state
            .getIn(['form', 'attachDocuments'])
            .toJS()
            .filter((file) => file.id !== action.file.id)
        )
      );

      // Remove the validation message for this requiredDocumentId
      const validationMessages = newState.getIn(['form', 'validationMessages']);
      
      const filteredMessages = validationMessages.filter(
        msg =>
          (msg.get('RequiredDocumentId') || msg.get('requiredDocumentId')) !==
          action.file.requiredDocumentId
      );
      return newState.setIn(['form', 'validationMessages'], filteredMessages);
    case LOAD_CLAIM_ATTACHMENTS_SUCCESS:
      return state
        .setIn(
          ['form', 'attachDocuments'],
          fromJS(
            action.files.map((file) => ({
              id: file.id,
              name: file.fileName,
              benefitCode: file.benefitCode,
              requiredDocumentId: file.claimRequiredDocumentId,
              groupName: file.groupName,
              success: file.success,
              message: file.message
            }))
          )
        );
    case RESET:
      return initialState;
    default:
      return state;
  }
}

export default stepSupportingDocumentsReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepSupportingDocuments/reducer.js